import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import routes from '@/constants/routes';
import { useAuthenticationStore, useSidebarStore } from '@/store';

const SignOut = () => {
	const navigate = useNavigate();
	const resetAuthentication = useAuthenticationStore((state) => state.resetState);
	const resetSidebar = useSidebarStore((state) => state.resetState);

	// TODO maybe logout hook would be better. logout path route looks like hack
	useEffect(() => {
		resetAuthentication();
		resetSidebar();
		navigate(routes['/login']);
	}, []);

	return null;
};

export default SignOut;
